// Licitações › Documentos da empresa (CONSULTA).
//
// Era a aba "Documentos da empresa (consulta)" dentro de ComercialLicitacoes;
// subiu pro hub em 2026-09-02. O acervo é mantido pelo Administrativo
// (2026-08-19): aqui só se consulta e baixa. Declaração específica de edital
// continua sendo criada na tela da licitação — o backend separa os dois pelo
// escopo do documento.
//
// O gate de acesso é a perm da aba no hub
// (comercial.licitacoes.documentos_empresa.ver) — por isso não há <Se> aqui.
import { Typography, App as AntApp, Alert, Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PainelDocumentosEmpresa } from '../administrativo-documentos/PainelDocumentosEmpresa';
import { usePerms } from '../../hooks/usePerms';

const { Title, Text } = Typography;

function PaginaDocumentosEmpresaInner() {
  const nav = useNavigate();
  const { pode } = usePerms();
  return (
    <div style={{ width: '100%', margin: '16px 0', padding: '0 24px', boxSizing: 'border-box' }}>
      <Title level={4} style={{ margin: 0, color: '#020D7F' }}>Documentos da empresa</Title>
      <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 14 }}>
        Documentação da empresa para habilitação em edital.
      </Text>
      <Alert type="info" showIcon style={{ marginBottom: 12 }}
        message="Consulta ao acervo da empresa"
        description={
          <Space wrap>
            <span>Cadastro e atualização ficam em <strong>Administrativo › Documentos da empresa</strong>. Aqui você consulta e baixa.</span>
            {pode('administrativo.documentos_empresa.ver') && (
              <Button size="small" type="link" style={{ padding: 0 }}
                onClick={() => nav('/administrativo/documentos')}>Abrir o acervo →</Button>
            )}
          </Space>
        } />
      <PainelDocumentosEmpresa modo="leitura" />
    </div>
  );
}

export default function PaginaDocumentosEmpresa() {
  return (
    <AntApp>
      <PaginaDocumentosEmpresaInner />
    </AntApp>
  );
}
